import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';

import { CoreDataClient, ListCoreDataResponse, ListPermissionsResponse } from '../api/clients';
const CACHE_SIZE = 1;

@Injectable({
  providedIn: 'root',
})
export class CoreDataService {
  private readonly coreDataClient = inject(CoreDataClient);


  private cache$: Observable<ListCoreDataResponse> | undefined = undefined;
  private permissions: Observable<ListPermissionsResponse> | undefined = undefined;

  listCoreData(): Observable<ListCoreDataResponse> {
    if (!this.cache$) {
      this.cache$ = this.coreDataClient.getCoreData().pipe(
        shareReplay(CACHE_SIZE)
      );
    }

    return this.cache$;
  }

  listPermissions(): Observable<ListPermissionsResponse> {
    if (!this.permissions) {
      this.permissions = this.coreDataClient.listPermissions().pipe(
        shareReplay(CACHE_SIZE)
      );
    }
    return this.permissions;
  }

  clearCache(): void {
    this.cache$ = undefined;
  }
}
